const Portfolio_Data = [
  {
    id: 1,
    category: "APPLICATION",
    totalLike: "600",
    title: "Happy Paws BD",
    subtitle: "Full-Stack Web Application for Pet Owners",
    image: "./image/Portfolio_image/portfolio1.jpg",
    description:
      "Happy Paws BD is a comprehensive pet care platform committed to enhancing the health and happiness of your pets. Our services include veterinary consultations, pet adoption, lost & found service, rescue service, informative health blogs, and an online shop for all your pet supply needs.",
    technologies: [
      "HTML5",
      "CSS3",
      "JavaScript (ES6+)",
      "React.js",
      "Material UI",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Firebase",
    ],
    features: [
      "Responsive Design: Ensures a seamless experience across all devices.",
      "User Authentication: Secure login and registration using Firebase Authentication.",
      "Online Shop: A wide range of pet products available for purchase.",
      "Pet Adoption: Detailed profiles and information about pets available for adoption.",
      "Appointment Booking: Easy scheduling of veterinary appointments.",
      "Lost & Found: Dedicated section to report and find lost pets.",
      "Rescue Service: Immediate assistance for pets in distress.",
      "Health Blogs: Informative and engaging health blogs written by experts.",
      "Veterinary Consultations: Professional veterinary consultations both online and offline.",
    ],
    view: "https://happypawsbd.onrender.com",
  },
  {
    id: 9,
    category: "ECOMMERCE",
    totalLike: "950",
    title: "Parts Bazar",
    subtitle: "E-Commerce Platform for Vehicle Parts & Accessories",
    image: "./image/Portfolio_image/portfolio8.jpg",
    description:
      "Parts Bazar is a robust, user-friendly e-commerce platform designed for sourcing automotive parts and accessories. It allows users to find exact fit parts for their vehicles, explore top brands, read blogs, watch tutorials, and enjoy secure shopping with fast delivery across Bangladesh.",
    technologies: [
      "HTML5",
      "CSS3",
      "JavaScript (ES6+)",
      "React.js",
      "Next.js",
      "Tailwind CSS",
      "ShadCN UI",
      "Redux Toolkit",
      "Node.js",
      "Express.js",
      "MongoDB",
      "NextAuth",
    ],
    features: [
      "Responsive Design: Fully optimized across desktop, tablet, and mobile devices.",
      "Product Filtering: Filter products by category, brand, price, and compatibility.",
      "Vehicle Fit Search: Select vehicle details to find exact matching parts.",
      "Dynamic Product Listings: Real-time product updates, offers, and stock visibility.",
      "Deals of the Day: Highlight time-limited promotional items.",
      "Top Brands & Categories: Easy access to best-selling products and manufacturers.",
      "Blog & Video Integration: Educational blogs and featured videos for user guidance.",
      "Customer Reviews: Carousel of real client feedback and testimonials.",
      "Add to Cart & Wishlist: Seamless shopping experience with wishlist and cart features.",
      "FAQ Section: Accordion-based support for customer queries.",
      "Secure Checkout: Integrated with popular payment gateways and mobile apps.",
      "Admin Dashboard: For product, order, and user management.",
    ],
    view: "https://partsbazar.vercel.app/",
  },
  {
    id: 2,
    category: "APPLICATION",
    totalLike: "750",
    title: "Tournee en Mymensingh",
    subtitle: "A website for travel enthusiasts offering.",
    image: "./image/Portfolio_image/portfolio2.jpg",
    description:
      "Explore the perfect getaway with our comprehensive travel platform, designed for tour enthusiasts and seamless booking experiences. Whether you're looking to embark on an adventure or relax in a serene destination, our site offers a wide range of tours and activities to cater to all your travel desires.",

    technologies: [
      "HTML5",
      "Vanilla CSS",
      "JavaScript",
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Firebase",
    ],
    features: [
      "Tour Packages: Descriptions of tour packages, including, highlights, and pricing.",
      "Choose Place: Easily select preferred tour destinations and dates.",
      "Cancel Order: Simple and hassle-free process for canceling booked tours.",
      "Delete Requests: Admins can remove unwanted tour requests.",
      "Complete Requests: Admins can mark tour requests as completed.",
      "Create Tour Packages: Admins can add and customize new tour packages to the platform.",
      "Tour Guide Details: Information about tour guides and their experience.",
      "Responsive Design: Ensures a seamless experience across all devices.",
      "User Authentication: Secure login and registration using Firebase Authentication.",
    ],
    view: "https://tournee-en-mymensingh-mlyg.onrender.com/",
  },
  {
    id: 11,
    category: "AI CONTENT PLATFORM",
    totalLike: "370",
    title: "Vocalize Pro",
    subtitle: "AI-Powered Content Generation & Social Media Management",
    image: "./image/Portfolio_image/portfolio7.jpg",
    description:
      "Vocalize Pro is an all-in-one AI-powered platform that transforms audio/video into blog articles, social media content, and summaries, while offering robust tools to manage and analyze content across all major social platforms. It enables creators, marketers, and brands to streamline their content workflows from transcription to publishing and performance tracking.",
    technologies: [
      "Next.js",
      "Tailwind CSS",
      "Shadcn UI",
      "OpenAI API",
      "Social Media APIs",
      "Zod Validation",
      "Recharts",
      "NextAuth",
      "AI Transcription Engine",
      "AI Content Generation Engine",
      "AI Image Generation Engine",
      "AI Video Generation Engine",
      "ChatGPT 4.0 Integration",
      "Social Media APIs",
      "Cloud Storage APIs",
    ],
    features: [
      "AI Transcription: Convert audio/video into accurate and editable text.",
      "Multi-Format Output: Automatically generate posts, summaries, and articles.",
      "Cross-Platform Publishing: Publish or schedule content to Facebook, LinkedIn, Instagram, TikTok, Twitter, and YouTube.",
      "Dashboard Analytics: Visualize engagement metrics like views, likes, comments, and performance over time.",
      "Post Progress Tracking: Monitor content type progress—articles, summaries, blogs, and posts.",
      "Template System: Access 100+ reusable content templates for various platforms.",
      "Cloud Integrations: Import recordings from Google Drive, Zoom, and Apple Podcasts.",
      "Word & Storage Tracking: Free-tier usage tracking for words and storage with upgrade options.",
      "Referral System: Invite users and earn rewards via referral points.",
      "Subscription Tiers: Free, Standard, Advanced, and Pro plans with scalable post, word, and storage limits.",
    ],
    view: "https://vocalizepro.vercel.app/",
  },
  {
    id: 10,
    category: "TECH BUSINESS",
    totalLike: "480",
    title: "TechServe4U",
    subtitle: "Enterprise-Grade eCommerce Tech Solutions",
    image: "./image/Portfolio_image/portfolio9.jpg",
    description:
      "TechServe4U is a full-service eCommerce technology company delivering scalable, high-performance digital solutions for online businesses. From custom storefront development to integrated logistics, payment systems, and SaaS tools — we help brands build, manage, and grow their digital retail presence with speed and confidence.",
    technologies: [
      "JavaScript",
      "TypeScript",
      "Next.js",
      "Tailwind CSS",
      "SCSS",
      "Framer Motion",
    ],
    features: [
      "Custom eCommerce Development: Tailored storefronts and shopping experiences built with modern frameworks.",
      "SaaS-Based Store Platform: Ready-to-launch online shop solutions powered by cloud infrastructure.",
      "Payment Gateway Integration: Secure, multi-currency payment processing with global compatibility.",
      "Smart Order Management: Track inventory, process orders, and manage fulfillment effortlessly.",
      "Responsive Design: Optimized UX across mobile, tablet, and desktop devices.",
      "Advanced Analytics: Real-time dashboards and data insights for smarter business decisions.",
      "Marketing & SEO Tools: Built-in tools to boost visibility, sales, and customer retention.",
      "Fast Delivery & Logistics API: Integrated shipping partners for smooth order delivery.",
      "Consulting & Support: Strategic guidance and 24/7 technical support for scaling your business.",
    ],
    view: "https://techserve4u.vercel.app/",
  },
  {
    id: 3,
    category: "APPLICATION",
    totalLike: "630",
    title: "Puppy",
    subtitle: "A website for purchasing various breeds puppies.",
    image: "./image/Portfolio_image/portfolio3.jpg",
    description:
      "Discover and purchase puppies of various breeds with ease on our comprehensive platform. From detailed puppy profiles to secure order management, our site offers everything you need for a seamless puppy buying experience.",
    technologies: [
      "HTML5",
      "Vanilla CSS",
      "JavaScript",
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Firebase",
    ],
    features: [
      "Puppy Profiles: Information about each puppy breed in details.",
      "Choose Puppy: Easily browse and select the perfect puppy from a curated list.",
      "User Dashboard: Personalized dashboard for users to manage their orders.",
      "My Order: View detailed summaries of orders before finalizing the purchase.",
      "Add Review: Share your experience and feedback by leaving reviews.",
      "Add New Breed: Admins can add and showcase new breeds on the platform.",
      "Manage Breed Packages: Admins can create, update, and manage breed packages.",
      "Manage Orders: Admins can view, process, and update the status of customer orders.",
      "Admin Management: Admins can assign administrative privileges to other users.",
      "Responsive Design: Ensures a seamless experience across all devices.",
      "User Authentication: Secure login and registration using Firebase Authentication.",
    ],
    view: "https://puppy-qxq2.onrender.com/",
  },
  // {
  //   id: 4,
  //   category: "PORTFOLIO",
  //   totalLike: "360",
  //   title: "My Portfolio",
  //   subtitle: "My Portfolio: Skills, Projects, Experiences",
  //   image: "./image/Portfolio_image/portfolio4.jpg",
  //   description:
  //     "Welcome to my portfolio site, showcasing my skills, projects, and professional experience. Explore my journey and the work I've done in the field of web development.",
  //   technologies: [
  //     "HTML5",
  //     "Vanilla CSS",
  //     "Tailwind CSS",
  //     "JavaScript",
  //     "React.js",
  //   ],
  //   features: [
  //     "Skill Showcase: List of my technical skills in frontend, backend, tools, and design.",
  //     "Project Portfolio: Collection of my projects with descriptions, technologies, features, and links.",
  //     "Educational Qualifications: Details of my academic background and certifications.",
  //     "Job Experience: Overview of my job positions and responsibilities.",
  //     "My Blog: Articles on web development, technology, and industry insights.",
  //     "Responsive Design: Seamless experience across all devices.",
  //     "Interactive Elements: Engaging animations and interactive features.",
  //     "Contact Form: Form for clients or collaborators to reach me.",
  //     "Downloadable Resume: Option to download my resume.",
  //     "Testimonials: Client and peer testimonials for credibility.",
  //   ],
  //   view: "https://myportfolio-f0ba.onrender.com/",
  // },
  // {
  //   id: 5,
  //   category: "APPLICATION",
  //   totalLike: "280",
  //   title: "Pet Care",
  //   subtitle: "Dedicated to the well-being of pet animals",
  //   image: "./image/Portfolio_image/portfolio5.jpg",
  //   description:
  //     "Our website offers a wide range of services designed specifically for pets, including detailed profiles and information about veterinarians. Users can explore different pet care options, read and leave reviews, and benefit from a responsive design that provides a smooth experience on any device. Additionally, secure login and registration are managed through Firebase Authentication to ensure the safety of user information.",
  //   technologies: [
  //     "HTML5",
  //     "CSS3",
  //     "Boostrap",
  //     "JavaScript (ES6+)",
  //     "React.js",
  //     "Node.js",
  //     "Express.js",
  //     "MongoDB",
  //     "Firebase",
  //   ],
  //   features: [
  //     "Diverse Pet Services: Explore various services for different types of pets.",
  //     "User Reviews: Read and leave feedback on services.",
  //     "Veterinarian Profiles: Access detailed information about veterinarians.",
  //     "Responsive Design: Optimized for all devices.",
  //     "User Authentication: Secure login and registration with Firebase.",
  //   ],
  //   view: "https://pet-care-7a60.onrender.com/",
  // },
  // {
  //   id: 6,
  //   category: "APPLICATION",
  //   totalLike: "690",
  //   title: "Honda CBR",
  //   subtitle: "A showcase website for the Honda CBR",
  //   image: "./image/Portfolio_image/portfolio6.jpg",
  //   description:
  //     " This website features a comprehensive showcase of the Honda CBR, complete with client testimonials, a newsletter subscription option, and a section for frequently asked questions. Designed to be fully responsive, it ensures an optimal viewing experience across all devices.",
  //   technologies: ["HTML5", "Vanilla CSS"],
  //   features: [
  //     "Subscribe to Newsletter: Stay updated with the latest news and updates.",
  //     "Client Testimonials: Hear from satisfied customers.",
  //     "Frequently Asked Questions: Find answers to common queries.",
  //     "Honda CBR Showcase: Discover the features and highlights of the Honda CBR.",
  //     "Responsive Design: Enjoy a seamless experience on any device.",
  //   ],
  //   view: "https://main--nervous-brattain-208662.netlify.app/",
  // },
  // {
  //   id: 7,
  //   category: "APPLICATION",
  //   totalLike: "455",
  //   title: "Azure Dream Lodge",
  //   subtitle: "Landing page of a hotel service provider",
  //   image: "./image/Portfolio_image/portfolio10.jpg",
  //   description:
  //     "Azure Dream Lodge is a luxurious hotel offering a serene escape for travelers. Our services include online booking, room service, and a variety of amenities to ensure a comfortable stay.",
  //   technologies: ["HTML5", "CSS3"],
  //   features: [
  //     "Responsive Layout: Optimized for desktop, tablet, and mobile screens.",
  //     "Elegant Hero Section: Includes headline, video prompt, and search availability form.",
  //     "Room Search: Interactive filters for check-in/check-out, guests, and room types.",
  //     "Image Gallery: High-quality images showcasing room types and hotel ambiance.",
  //     "Featured Rooms: Multiple room types with pricing, size, guest capacity, and amenities.",
  //     "Customer Reviews: Testimonial section highlighting guest satisfaction.",
  //     "Navigation Bar: Clear links to Home, About, Rooms, Blog, Contact, and Reservation.",
  //     "Social Media Integration: Icons linking to Facebook, LinkedIn, and Instagram.",
  //     "Footer Section: Includes quick links, appointment services, and contact info.",
  //     "Modern Aesthetic: Clean typography, consistent branding, and subtle animations.",
  //   ],
  //   view: "https://nasifjihan.github.io/AzureDream-Lodge",
  // },
  // {
  //   id: 8,
  //   category: "APPLICATION",
  //   totalLike: "850",
  //   title: "SalesRank.AI",
  //   subtitle: "AI-Powered Sales Coaching Platform",
  //   image: "./image/Portfolio_image/portfolio10.jpg",
  //   description:
  //     "SalesRank.AI is an advanced AI-driven sales coaching platform designed to boost sales team performance through real-time suggestions, script generation, and deal-closing strategies. It offers interactive coaching, performance analytics, and actionable tools to help businesses convert leads into clients with confidence.",
  //   technologies: [
  //     "HTML5",
  //     "CSS3",
  //     "JavaScript (ES6+)",
  //     "React.js",
  //     "Tailwind CSS",
  //     "OpenAI API",
  //   ],
  //   features: [
  //     "AI Sales Coach: Provides real-time suggestions and negotiation tips for sales reps.",
  //     "Interactive Chat: Simulated chat interface for practice and coaching.",
  //     "Script Generator: Instantly create sales scripts tailored to your needs.",
  //     "Pitch Practice: Practice delivering your pitch with AI feedback.",
  //     "Confidence Analysis: Visual display of performance levels in objection handling.",
  //     "Live Coaching Suggestions: Get instant tips on overcoming objections or closing.",
  //     "Courses Section: Curated learning materials and structured courses for skill building.",
  //     "FAQ Accordion: Organized section addressing common questions.",
  //     "Responsive Design: Optimized for all screen sizes and devices.",
  //     "Testimonial Slider: Social proof through client feedback and carousel display.",
  //   ],
  //   view: "https://sales-rank-ai.vercel.app",
  // },
];

export default Portfolio_Data;
